import React        from 'react'

const Container = props => {
    return (
        <div className="landing-container">
            { props.children }
        </div>
    )
}

export default Container
